import { Geolocation, GeolocationAction, GeolocationActions } from "@/types/geolocation";

const geolocationReducer = (state: Geolocation, action: GeolocationAction): Geolocation => {
    switch (action.type) {
        case GeolocationActions.SET_DATA: {
            return {
                country: action.country,
                currency: action.currency,
                ipAddress: action.ipAddress,
                city: action.city,
                postalCode: action.postalCode,
                region: action.region,
            };
        }
        case GeolocationActions.SET_CURRENCY: {
            return {
                ...state,
                currency: action.currency,
            };
        }
    }
};

export default geolocationReducer;
